var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5072_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#C5E2C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0889 31.3777C11.9555 31.3777 11.8666 31.2888 11.8666 31.1555C11.8666 31.0222 11.9555 30.9333 12.0889 30.9333H27.9111C28.0444 30.9333 28.1333 31.0222 28.1333 31.1555C28.1333 31.2888 28.0444 31.3777 27.9111 31.3777H12.0889Z",
    fill: "#42413F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0666 28.4889C18.9333 28.4889 18.8444 28.4 18.8444 28.2667C18.8444 28.1333 18.9333 28.0444 19.0666 28.0444H27.9111C28.0444 28.0444 28.1333 28.1333 28.1333 28.2667C28.1333 28.4 28.0444 28.4889 27.9111 28.4889H19.0666Z",
    fill: "#42413F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9777 25.6444C20.8444 25.6444 20.7111 25.5111 20.7111 25.4222C20.7111 25.2889 20.8444 25.1555 20.9777 25.1555H27.9111C28.0444 25.1555 28.1333 25.2889 28.1333 25.4222C28.1333 25.5111 28.0444 25.6444 27.9111 25.6444H20.9777Z",
    fill: "#42413F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6 22.7555C23.4666 22.7555 23.3777 22.6667 23.3777 22.5333C23.3777 22.4 23.4666 22.3111 23.6 22.3111H27.9111C28.0444 22.3111 28.1333 22.4 28.1333 22.5333C28.1333 22.6667 28.0444 22.7555 27.9111 22.7555H23.6Z",
    fill: "#42413F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.211 10.7939L24.8227 12.8801L23.7681 14.7069L20.1564 12.6207L21.211 10.7939Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5333 12L20.8444 11.4222L22.6667 12.4445C22.8 12.5334 22.8889 12.7556 22.7555 12.9334C22.6667 13.0667 22.4889 13.1111 22.3111 13.0222L20.5333 12Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2 10.8L24.8444 12.8889L25.6 11.5111C26.0444 10.7556 25.7777 9.77778 25.0222 9.33334L24.1777 8.84445C23.4222 8.40001 22.4444 8.66667 22 9.42223L21.2 10.8Z",
    fill: "#D51660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8666 31.1555L12 26.7111L15.6 28.7999L11.8666 31.1555Z",
    fill: "#EDBF8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8666 31.1556L11.9555 29.0222L14.0889 29.6444C14.1333 29.6444 14.1777 29.6444 14.2222 29.6889L11.8666 31.1556Z",
    fill: "#51504E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6198 28.8117L12.016 26.7298L20.1641 12.6197L23.7679 14.7016L15.6198 28.8117Z",
    fill: "#E2722F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4282 28.1238L13.2071 27.4186L21.3552 13.3084L22.5763 14.0136L14.4282 28.1238Z",
    fill: "#F6882F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5777 14L14.4444 28.1333L15.6 28.8L23.7777 14.7111L22.5777 14Z",
    fill: "#F6AE4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5072_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.5ad87ec6a5c545f164ebb928081d4e4d.svg";
export { ForwardRef as ReactComponent };